export function draftNombreListado(numero) {
  return `Draft ${String(numero).padStart(2, '0')}`;
}

function draftNombre(numero) {
  return draftNombreListado(numero);
}

/** Nombre visible en grilla /packinglist (incluye Draft cuando el PL está dividido). */
export function nombrePackingListEnListado(row) {
  const base = String(row?.nombre || '').trim();
  const draft = String(row?.draft_nombre || '').trim();
  if (!draft || draft === '—') return base;
  return base ? `${base} ${draft}` : draft;
}

/** Expande visualmente un Packing List con múltiples Drafts en una fila por Draft. */
export function expandirPackingListsPorDraft(rows) {
  return (rows || []).flatMap((row) => {
    const varios = String(row?.modo_draft || '').toLowerCase() === 'varios';
    const cantidad = varios
      ? Math.max(1, Math.min(20, Number(row?.cantidad_drafts) || 2))
      : 1;
    const baseNombre = String(row?.nombre || '').trim();

    if (!varios) {
      const item = {
        ...row,
        draft_label: null,
        draft_nombre: '—',
        nombre_listado: baseNombre,
        _rowKey: `pl-${row.id}`,
      };
      return [item];
    }

    return Array.from({ length: cantidad }, (_, index) => {
      const numero = index + 1;
      const draft_nombre = draftNombre(numero);
      return {
        ...row,
        draft_label: String(numero),
        draft_nombre,
        nombre_listado: baseNombre ? `${baseNombre} ${draft_nombre}` : draft_nombre,
        _rowKey: `pl-${row.id}-draft-${numero}`,
      };
    });
  });
}
